import { ITranslations } from '@/i18n/ITranslations';

export const en: ITranslations = {
  'admin.emptySection':
    'This section "<strong>((sectionName))</strong>" seems to be empty, which probably is a mistake. Please contact your system adminstrator.',
  'general.appStartPage': 'App Root Page',
  userName: 'Username',
  userRole: 'User role',
  momentInTime: 'Moment in time',
  archive: `Archive`,
  account: `Account`,
  options: `Options`,
  'archive.type.monthly': 'Monthly',
  'archive.type.weekly': 'Weekly',
  'billingType.EUROPE': 'Europe',
  'billingType.OTHER': 'Other',
  'billingType.UK': 'UK',
  'contacts.createNewCompany': `((icon)) Create new company '((searchValue))'...`,
  'contacts.createNewPerson': `((icon)) Create new person '((searchValue))'...`,
  'contacts.editOrCopy': 'Edit / Copy Contact',
  'contacts.new': 'New Contact',
  'contacts.new.success': 'New contact created successfully.',
  'contacts.new.error': 'Failed to create new contact.',
  'contacts.edit.success': 'Contact edited successfully.',
  'contacts.edit.error': 'Failed to edit contact.',
  'contacts.copy.success': 'Contact copied successfully.',
  'contacts.copy.error': 'Failed to copy contact.',
  'contacts.noFurtherContactsAvailable': 'No further customers available',
  'customer.address': 'Address',
  'customer.addressAddition': 'Additional Info',
  'customer.city': 'City',
  'customer.company': 'Company',
  'customer.country': 'Country',
  'customer.email': 'Email',
  'customer.firstName': 'First Name',
  'customer.houseNr': 'House Nr.',
  'customer.lastName': 'Last Name',
  'customer.phoneNumber': 'Phone Number',
  'customer.street': 'Street',
  'customer.zipCode': 'Zipcode',
  'general.apply': 'Apply',
  'general.area.EUROPE': 'Europe',
  'general.area.OTHER': 'Other',
  'general.area.UK': 'UK',
  'general.create': 'Create',
  'general.duplicate': 'Duplicate',
  'general.disable': 'Disable',
  'general.edit': 'Edit',
  'general.copy': 'Copy',
  'general.copyPrefix': 'COPY-OF-',
  'general.new': 'New',
  'general.no': 'No',
  'general.open': 'Open',
  'general.positions': 'Positions',
  'general.redirect': 'Redirect',
  'general.saveChanges': 'Save Changes',
  'general.saveNewContact': 'Save New Contact',
  'general.saveNewCopy': 'Save New Copy',
  'general.showMore': 'Show More',
  'general.yes': 'Yes',
  'general.optional': 'Optional',
  'general.forAll': 'For anyone',
  'internalOrder.position': 'Position',
  'internalOrder.total': 'Total',
  'internalOrder.creation.success': 'Internal order successfully created',
  'internalOrder.creation.error': 'Creation of internal order failed',
  'language.de': 'German',
  'language.en': 'English',
  'loading.checkingSession': 'Checking Session...',
  'loading.fetchDataError': 'An error occurred when retrieving basic data',
  'loading.fetchSettingsError': 'An error occurred when retrieving basic settings',
  'loading.pleaseWait': 'Please wait...',
  'loading.redirecting': 'Redirecting...',
  'loading.retrievingData': 'Retrieving basic data...',
  'loading.retrievingSettings': 'Retrieving basic settings...',
  'loading.tryAgain': 'Try again',
  'order.declined.reason': 'Reason',
  'order.noFurtherOrdersAvailable': 'No further orders available',
  'order.track': 'Track',
  'order.redirect': 'Redirect order ((order))',
  'order.redirect.success': 'Order successfully redirected',
  'order.redirect.error': 'Redirecting order failed',
  'order.trackingNumber': 'Tracking-ID',
  'order.trackingLinkText': "Click here to track this Package on the Shipping Service's Website",
  'order.noCustomerSelected': 'No customer selected',
  'order.searchForCustomer': 'Search for a customer...',
  'order.searchForAnotherCustomer': 'Search for a different customer...',
  'order.new.success': 'Order successfully created.',
  'order.new.error': 'Order could not be created.',
  'order.positions': 'Positions',
  'order.positions.titles': 'Title',
  'order.positions.multipleGroupsError': 'Positions from multiple product groups (((productGroups))) are not allowed',
  'order.positions.type': 'Field of use',
  'order.positions.forOrders': 'For Orders',
  'order.positions.forPreorders': 'For Preorders',
  'order.positions.forBoth': 'For both',
  'order.positions.noTypeChangeAllowed.ORDER':
    'Field of use cannot be changed for an existing position. Create a new position for orders instead.',
  'order.positions.noTypeChangeAllowed.PREORDER':
    'Field of use cannot be changed for an existing position. Create a new position for preorders instead.',
  'order.positions.amount.aboveExpressTotalMax': 'Maximum total amount for EXPRESS preorders is ((expressLimitTotal))',
  'order.positions.id': 'ID',
  'order.positions.userRoleCannotBeChanged':
    'The user role cannot be changed for an existing position. Create a new position for ((userRole)) instead.',
  'order.positions.autoId': 'Auto-generated ID',
  'order.positions.autoId.explanation':
    'This automatically generated ID is based on the field of use and the English position title and will be used internally. You cannot manually change it.',
  'order.paymentInterval': 'Payment Interval',
  'order.billingType': 'Billing Type',
  'order.search': 'Search',
  'order.searchPlaceholder': 'Free search...',
  'order.approve': 'Approve',
  'order.approve.date': 'Approval Date',
  'general.createdBy': 'Created by',
  'order.customer': 'Customer',
  'order.date': 'Created at',
  'order.decline': 'Decline',
  'order.internalOrder': 'Internal Order',
  'order.order': 'Order',
  'order.position.amount': 'Amount',
  'order.position.minAmount': 'Minimum Quantity',
  'order.position.maxAmount': 'Maximum Quantity',
  'order.position.set': 'Set',
  'order.position.unset': 'Unset',
  'order.position.limitNotSet': 'Not set',
  'order.position.maxAmount.error.lowerThanMin': 'Maximum quantity is lower than minimum quantity',
  'order.position.minAmount.error.isZero': 'Please unset the minimum quantity for this case',
  'order.position.maxAmount.error.isZero': 'A maximum quantity of 0 is not valid',
  'order.position.amount.belowMin': 'Minimum amount for this position is ((minAmount))',
  'order.position.amount.aboveMax': 'Maximum amount for this position is ((maxAmount))',
  'order.position.amount.aboveStandardMax':
    'Maximum amount per position in case of STANDARD preorders is ((standardLimitPerPosition))',
  'order.position.pos': 'POS',
  'order.preOrder': 'Preorder',
  'order.priority.HIGH': 'High',
  'order.priority.LOW': 'Low',
  'order.priority.MID': 'Medium',
  'order.status': 'Status',
  'order.status.ALL_OPEN_ORDERS': 'All open orders',
  'order.status.ALL_OPEN_PREORDERS': 'All open preorders',
  'order.status.ALL_ORDERS': 'All orders',
  'order.status.ALL_PREORDERS': 'All preorders',
  'order.status.BEING_PREPARED': 'In preparation',
  'order.status.DELIVERED': 'Delivered',
  'order.status.FLAWED': 'Flawed',
  'order.status.INTERNAL_ORDER_COMPLETED': 'Internal Order Completed',
  'order.status.NEW': 'New',
  'order.status.DECLINED': 'Declined',
  'order.status.PREORDER': 'Preorder',
  'order.status.PREORDER_COMPLETED': 'Preorder completed',
  'order.status.SHIPPED': 'Shipped',
  'order.updatedAt': 'Updated at',
  'general.updatedBy': 'Updated by',
  'general.forWhom': 'For ((who))',
  'general.date.inThePast': 'Date is in the past',
  'general.date.inTheFuture': 'Date is in the future',
  'page.ADD_NEW_ORDER': 'New Order',
  'page.ADD_NEW_PREORDER': 'New Preorder',
  'page.CONTACT_LIST': 'Contact List',
  'page.EDIT_NEW_ORDER': 'Edit new order',
  'page.EDIT_ORDER': 'Edit order',
  'page.POSITIONS': 'Positions',
  'page.ADD_NEW_POSITION': 'Add new position',
  'page.EDIT_POSITION': 'Edit position',
  'page.COPY_POSITION': 'Copy position',
  'payment.allocation': 'Allocation',
  'payment.date': 'Date',
  'payment.deliveryLocation': 'Delivery Location',
  'payment.open': 'Open',
  'payment.paid': 'Paid',
  'payment.payments': 'Payments',
  'payment.submit': 'Create',
  'payment.surplus': 'Surplus',
  'payment.total': 'Total',
  'payment.creation.success': 'Payment successfully created',
  'payment.creation.error': 'Creation of payment failed',
  'paymentInterval.HALF_YEARLY': 'Half Yearly',
  'paymentInterval.MONTHLY': 'Monthly',
  'paymentInterval.QUARTERLY': 'Quarterly',
  'paymentInterval.YEARLY': 'Yearly',
  'paymentInterval.paymentInterval': 'Payment Interval',
  'paymentInterval.xMonths.x': 'Every month',
  'paymentInterval.xMonths.1': 'One month',
  'paymentInterval.xMonths.2': 'Split upon two months',
  'paymentInterval.xMonths.3': 'Split upon three months',
  'paymentInterval.xMonths.4': 'Split upon four months',
  'paymentInterval.xMonths.5': 'Split upon five months',
  'paymentInterval.xMonths.6': 'Split upon six months',
  'paymentInterval.xMonths.7': 'Split upon seven months',
  'paymentInterval.xMonths.8': 'Split upon eight months',
  'paymentInterval.xMonths.9': 'Split upon nine months',
  'paymentInterval.xMonths.10': 'Split upon ten months',
  'paymentInterval.xMonths.11': 'Split upon eleven months',
  'paymentInterval.xMonths.12': 'Split upon twelve months',
  'preorder.noFurtherPreordersAvailable': 'No further preorders available',
  'preorder.new.success': 'Preorder successfully created',
  'preorder.new.error': 'Preorder creation failed',
  'preorder.deliveryConditions': 'Delivery Conditions',
  'preorder.deliveryConditions.text': '7 days after confirmation.',
  'preorder.express': 'Express',
  'preorder.limitReached': 'Express-Limit per Month reached',
  'preorder.maxAmount': 'Total Amount',
  'preorder.maxAmountExpress': 'Total Amount (max. ((maxAmount)))',
  'preorder.notes': 'Notes',
  'preorder.paymentConditions': 'Payment Conditions',
  'preorder.paymentConditions.text': 'TODO',
  'preorder.standard': 'Standard',
  'preorder.storageLocation': 'Storage Location',
  'preorder.type': 'Type',
  'section.ADD_NEW_INTERNAL_ORDER': 'Add internal order',
  'section.ADD_NEW_ORDER': 'Add new order',
  'section.ADD_NEW_PAYMENT': 'Add new payment',
  'section.ADD_NEW_PREORDER': 'Add new preorder',
  'section.ARCHIVE': 'Archive',
  'section.CONTACT_LIST': 'Contacts',
  'section.GUIDELINE': 'Guidelines',
  'section.NEW_ORDERS': 'New orders',
  'section.DECLINED_ORDERS': 'Declined orders',
  'section.ORDER_OVERVIEW': 'Order overview',
  'section.PAYMENTS': 'Payments',
  'section.PREORDER_OVERVIEW': 'Preorder overview',
  'section.ACCOUNT': 'Account',
  'section.OPTIONS': 'Options',
  'section.POSITIONS': 'Positions',
  'options.section.PRICES': 'Prices',
  'validation.alreadyExists': 'Exists already',
  'validation.cannotBeEmpty': 'Cannot be empty',
  'validation.invalidDate': 'Must be a valid date',
  'validation.invalidMail': 'Invalid mail address',
  'validation.invalidZipcode': 'Invalid zipCode',
  'validation.tooLong': 'Too long',
  'validation.firstNameTooLong': 'First name too long',
  'validation.lastNameTooLong': 'Last name too long',
  'validation.tooShort': 'Too short',
  'validation.firstNameTooShort': 'First name too short',
  'validation.lastNameTooShort': 'Last name too short',
  'validation.noCompanyButAlsoNoPerson': 'Company name OR person name required',
  'validation.noFirstName': 'First name required',
  'validation.noLastName': 'Last name required',
  'general.logoutConfirm': 'Do you really want to logout?',
  'general.close': 'Close',
  'general.createdAt': 'Created at',
  'general.updatedAt': 'Updated at',
  'general.sorting': 'Sorting',
  'order.showAllInStatus': "Show all orders with status '((status))'",
  'order.priority': 'Priority',
  'order.decide.approved.success': 'Successfully approved order',
  'order.decide.declined.success': 'Successfully declined order',
  'order.decide.approved.error': 'Error occurred while approving order',
  'order.decide.declined.error': 'Error occurred while declining order',
  'order.cancel': 'Cancel order',
  'order.cancel.confirm': `Do you really want to cancel order ((orderId))?`,
  'order.cancel.success': 'Order successfully cancelled',
  'order.cancel.error': 'Cancelling order failed',
  'order.sender': 'Sender',
  'order.sender.info.canSelect': '',
  'order.sender.info.canNotSelect': '',
  'order.sender.wasChanged': "The sender was automatically changed to '((newSender))'.",
  'order.sender.placeholder.canSelect': 'Please choose a sender...',
  'order.sender.placeholder.canNotSelect': 'Sender will be set automatically...',
  'general.ok': 'Ok',
  'general.cancel': 'Cancel',
  'general.cannotBeNegative': 'Cannot be negative',
  'general.cannotBeUndefined': 'Cannot be undefined',
  'general.cannotBeLowerThanX': 'Cannot be lower than ((minAmount))',
  'general.mustBeInteger': 'Has to be an integer',
  'price.currentPrice': 'Current Price',
  'price.newPrice': 'New Price',
  'price.submit.success': 'Price successfully updated',
  'price.submit.error': 'Updating price failed',
  'price.changePrice': 'Change price',
  'price.changePriceFirst': 'No price set yet... set now!',
  'price.hideHistory': 'Hide History',
  'price.showHistory': 'Show History',
  'price.setPrefix': 'Set ',
  'price.setSuffix': ' ago, by ((createdBy))',
  'price.PALLETS': 'Pallets Prices',
  'price.UK': 'UK Prices',
  'price.GENERIC.change': 'Change ((unit)) Price',
  'price.GENERIC.changeFirst': 'Set initial ((unit)) Price',
  'general.pleaseWait': 'Please wait...',
  'general.errorOccurred': 'An error occurred',
  'general.createdByAt': 'Created by <strong>((createdBy))</strong>, at <strong>((createdAt))</strong>',
  'general.updatedByAt': 'Last edited by <strong>((updatedBy))</strong>, at <strong>((updatedAt))</strong>',
  'general.showAll': 'Show all',
  'order.new.xHiddenOrders': { singular: '((x)) further new order hidden', plural: '((x)) further new orders hidden' },
  'order.declined.xHiddenOrders': {
    singular: '((x)) further declined order hidden',
    plural: '((x)) further declined orders hidden',
  },
  'order.goToFocusedView': 'Go to Focused View',
  'order.new.empty': 'No new orders available',
  'order.declined.empty': 'No declined orders available',
  'pagination.noResults': 'No results',
  'pagination.warningFiltersAreActive': 'Warning: filters are active!',
  'order.decide.approve.confirm':
    'Do you really want to approve order <span style="font-weight: bold;">((orderId))</span>?',
  'order.decide.decline.confirm':
    'Do you really want to decline order <span style="font-weight: bold;">((orderId))</span>?',
  'general.mandatory': 'mandatory',
  'general.logout': 'Logout',
  'position.submit.NEW': 'Create new position',
  'position.submit.COPY': 'Create new position (copy)',
  'position.submit.EDIT': 'Save changes',
  'position.submit.NEW.success': 'New position successfully created',
  'position.submit.COPY.success': 'New position (copy) successfully created',
  'position.submit.EDIT.success': 'Saving changes was successful',
  'position.submit.NEW.error': 'Creation of new position failed',
  'position.submit.COPY.error': 'Creation of new position (copy) failed',
  'position.submit.EDIT.error': 'Saving of position changes failed',
  'position.disable.warning.title': 'Disable position ((positionId))?',
  'position.disable.warning.description':
    'You are about to disable position ((positionId)). This means no user can use this position in future orders.\n\nAre you sure?',
  'position.disable.submit.success': 'Position successfully disabled',
  'position.disable.submit.error': 'Disabling of position failed',
  'archive.download.success': 'File download successful',
  'archive.download.error': 'File download failed',
  'payments.complete': 'Complete months (((count))):',
  'payments.incomplete': 'Outstanding months (((count))):',
};
